'use client';

import { memo } from 'react';
import { PropsWithLocale } from '@headless-workspace/glow-ds';
import { ComponentMemo } from '@headless-workspace/typings';
import { ConnectedUserInfo, useClientData } from '../../../../../src';
import { ConnectionBannerConnectedGreeting } from './ConnectionBannerConnectedGreeting';
import { ConnectionBannerGreetingSkeleton } from './ConnectionBannerGreetingSkeleton';
import { ConnectionBannerNotConnectedGreeting } from './ConnectionBannerNotConnectedGreeting';

type ConnectionBannerGreetingProps = PropsWithLocale & {
    isLoggingOut?: boolean;
    userInfo: ConnectedUserInfo | undefined;
    isLoading: boolean;
};

export const ConnectionBannerGreeting: ComponentMemo<ConnectionBannerGreetingProps> = memo(
    ({ locale, userInfo, isLoading, isLoggingOut = false }) => {
        const { getClientFlags } = useClientData();
        const isMySephoraActivated = getClientFlags('isMySephoraActivated');

        return (
            <div className={'flex flex-col items-start gap-1 w-connectionBannerInfo'}>
                {isLoading ? (
                    <ConnectionBannerGreetingSkeleton />
                ) : userInfo ? (
                    <ConnectionBannerConnectedGreeting
                        locale={locale}
                        userInfo={userInfo}
                        isLoggingOut={isLoggingOut}
                        isMySephoraActivated={isMySephoraActivated}
                    />
                ) : (
                    <ConnectionBannerNotConnectedGreeting locale={locale} isMySephoraActivated={isMySephoraActivated} />
                )}
            </div>
        );
    },
);

ConnectionBannerGreeting.displayName = 'ConnectionBannerGreeting';
